module.exports = __webpack_public_path__ + "img/title.cb948daf.png";